module.exports = __webpack_public_path__ + "static/img/merkel.0b529c7c.png";